import Home from './svgV3/Home.svg';
import HeadlessCMS from './svgV3/HeadlessCMS.svg';
import Personalization from './svgV3/Personalization.svg';
import Lytics from './svgV3/Lytics.svg';
import Automate from './svgV3/Automate.svg';
import BrandKit from './svgV3/BrandKit.svg';
import Launch from './svgV3/Launch.svg';
import DeveloperHub from './svgV3/DeveloperHub.svg';
import Marketplace from './svgV3/Marketplace.svg';
import Analytics from './svgV3/Analytics.svg';
import Administration from './svgV3/Administration.svg';
import AssetManagementLogo from './svgV3/AssetManagementLogo.svg';
import ComposableStudio from './svgV3/ComposableStudio.svg';
import ScholarHat from './svgV3/ScholarHat.svg';
import Polaris from './svgV3/Polaris.svg';
import DataAndInsights from './svgV3/DataAndInsights.svg';
import AgentOS from './svgV3/AgentOS.svg';

import ProductLogoHeadlessCMS from './svgV3/ProductLogoHeadlessCMS.svg';
import ProductLogoPersonalization from './svgV3/ProductLogoPersonalization.svg';
import ProductLogoLytics from './svgV3/ProductLogoLytics.svg';
import ProductLogoAutomate from './svgV3/ProductLogoAutomate.svg';
import ProductLogoBrandKit from './svgV3/ProductLogoBrandKit.svg';
import ProductLogoLaunch from './svgV3/ProductLogoLaunch.svg';
import ProductLogoDeveloperHub from './svgV3/ProductLogoDeveloperHub.svg';
import ProductLogoMarketplace from './svgV3/ProductLogoMarketplace.svg';
import ProductLogoAnalytics from './svgV3/ProductLogoAnalytics.svg';
import ProductLogoAdministration from './svgV3/ProductLogoAdministration.svg';
import ProductLogoAssetManagementLogo from './svgV3/ProductLogoAssetManagementLogo.svg';
import ProductLogoComposableStudio from './svgV3/ProductLogoComposableStudio.svg';
import ProductLogoVisualBuilder from './svgV3/ProductLogoVisualBuilder.svg';
import ProductLogoDataAndInsights from './svgV3/ProductLogoDataAndInsights.svg';
import ProductLogoAgentOS from './svgV3/ProductLogoAgentOS.svg';
import ProductLogoPlatformDiscovery from './svgV3/ProductLogoPlatformDiscovery.svg';
import PlatformDiscoveryBrandLogo from './svgV3/PlatformDiscoveryBrandLogo.svg'

import Logo from './svgV3/Logo.svg';
import ContentstackLogoGrey from './svgV3/ContentstackLogoGrey.svg';

export const iconComponentsV3 = {
    Home,
    HeadlessCMS,
    Personalization,
    Lytics,
    Automate,
    BrandKit,
    Launch,
    DeveloperHub,
    Marketplace,
    Analytics,
    Administration,
    AssetManagementLogo,
    ComposableStudio,
    ScholarHat,
    ProductLogoHeadlessCMS,
    ProductLogoPersonalization,
    ProductLogoLytics,
    ProductLogoAutomate,
    ProductLogoBrandKit,
    ProductLogoLaunch,
    ProductLogoDeveloperHub,
    ProductLogoMarketplace,
    ProductLogoAnalytics,
    ProductLogoAdministration,
    ProductLogoAssetManagementLogo,
    ProductLogoComposableStudio,
    Logo,
    ContentstackLogoGrey,
    ProductLogoVisualBuilder,
    ProductLogoPlatformDiscovery,
    PlatformDiscoveryBrandLogo,
    Polaris,
    DataAndInsights,
    ProductLogoDataAndInsights,
    AgentOS,
    ProductLogoAgentOS
};

export const iconNameV3 = {
    Home: 'Home',
    HeadlessCMS: 'HeadlessCMS',
    Personalization: 'Personalization',
    Lytics: 'Lytics',
    Automate: 'Automate',
    BrandKit: 'BrandKit',
    Launch: 'Launch',
    DeveloperHub: 'DeveloperHub',
    Marketplace: 'Marketplace',
    Analytics: 'Analytics',
    Administration: 'Administration',
    AssetManagementLogo: 'AssetManagementLogo',
    ComposableStudio: 'ComposableStudio',
    ScholarHat: 'ScholarHat',
    ProductLogoHeadlessCMS: 'ProductLogoHeadlessCMS',
    ProductLogoPersonalization: 'ProductLogoPersonalization',
    ProductLogoLytics: 'ProductLogoLytics',
    ProductLogoAutomate: 'ProductLogoAutomate',
    ProductLogoBrandKit: 'ProductLogoBrandKit',
    ProductLogoLaunch: 'ProductLogoLaunch',
    ProductLogoDeveloperHub: 'ProductLogoDeveloperHub',
    ProductLogoMarketplace: 'ProductLogoMarketplace',
    ProductLogoAnalytics: 'ProductLogoAnalytics',
    ProductLogoAdministration: 'ProductLogoAdministration',
    ProductLogoAssetManagementLogo: 'ProductLogoAssetManagementLogo',
    ProductLogoComposableStudio: 'ProductLogoComposableStudio',
    Logo: 'Logo',
    ContentstackLogoGrey: 'ContentstackLogoGrey',
    ProductLogoVisualBuilder: 'ProductLogoVisualBuilder',
    ProductLogoPlatformDiscovery: 'ProductLogoPlatformDiscovery',
    Polaris:'Polaris',
    PlatformDiscoveryBrandLogo:'PlatformDiscoveryBrandLogo',
    DataAndInsights: 'DataAndInsights',
    ProductLogoDataAndInsights: 'ProductLogoDataAndInsights',
    AgentOS: 'AgentOS',
    ProductLogoAgentOS: 'ProductLogoAgentOS'
}